export const extracurriculars = {
  title: "Activités Extrascolaires",
  metaDescription: "Activités extrascolaires à Gándara International School - Anglais, Musique, Cirque, Imaxina et plus",
  weeklySchedule: {
    title: "Programme Hebdomadaire",
    filterLabels: {
      english: "Anglais",
      xogos: "Jeux",
      music: "Musique", 
      circus: "Cirque",
      search: "Rechercher activité… (ex: Anglais)"
    },
    schedule: [
      {
        day: "Lundi",
        subtitle: "English Starters et Imaxina",
        sessions: [
          {
            title: "English Starters Groupe 1",
            time: "15h30 à 16h30",
            instructor: "Patri",
            badge: "3-5 ans",
            tags: ["english"]
          },
          {
            title: "English Starters Groupe 2", 
            time: "16h30 à 17h30",
            instructor: "Patri",
            badge: "3-5 ans",
            tags: ["english"]
          },
          {
            title: "Imaxina",
            time: "16h30 à 18h30",
            instructor: "Xavi",
            badge: "8–12 ans",
            tags: ["imaxina", "créativité"]
          }
        ]
      },
      {
        day: "Mardi",
        subtitle: "English Advance",
        sessions: [
          {
            title: "English Advance Groupe 1",
            time: "15h30 à 16h30",
            instructor: "Sandra",
            badge: "6–12 ans",
            tags: ["english"]
          },
          {
            title: "English Advance Groupe 2",
            time: "16h30 à 17h30", 
            instructor: "Sandra",
            badge: "6–12 ans",
            tags: ["english"]
          }
        ]
      },
      {
        day: "Mercredi",
        subtitle: "Jeux de Société (8-12 ans)",
        sessions: [
          {
            title: "Jeux de Société",
            time: "16h30 à 18h30",
            instructor: "Xavi",
            badge: "8–12 ans",
            tags: ["xogos"]
          }
        ]
      },
      {
        day: "Jeudi",
        subtitle: "Atelier de Musique et Cirque",
        sessions: [
      {
        title: "LET'S PLAY GUITAR",
        time: "15h30 à 16h30",
        instructor: "Óscar",
        badge: "8–12 ans",
        tags: ["music"]
      },
      {
        title: "ENJOY THE MUSIC",
        time: "16h30 à 17h30",
        instructor: "Óscar",
        badge: "5-8 ans",
        tags: ["music"]
      },
          {
            title: "Cirque",
            time: "17h30 à 18h30",
            instructor: "",
            badge: "8–12 ans",
            tags: ["circus"]
          }
        ]
      }
    ]
  },
  ludoteca: {
    title: "Service de Ludothèque",
    schedule: "Horaires de la ludothèque: 15h30 à 18h30",
    freeService: "Gratuit si l'on prend le déjeuner ou une autre activité extrascolaire",
    pricing: {
      title: "Prix de la ludothèque sans déjeuner ni extrascolaires:",
      dayPass: "Jour isolé: 8€/jour",
      oneDay: "Un jour par semaine: 25€/mois",
      twoDays: "Deux jours par semaine: 40€/mois",
      fiveDays: "Cinq jours par semaine: 100€/mois"
    }
  },
  activities: {
    title: "Activités Extrascolaires - Prix",
    list: [
      {
        name: "Imaxina",
        age: "8-12 ans",
        price: "40 €/mois",
        description: "Accompagnement et apprentissage à travers le jeu de rôle"
      },
      {
        name: "Jeux de Société",
        age: "8-12 ans",
        price: "40 €/mois",
        description: "Accompagnement à travers les jeux de société"
      },
      {
        name: "Anglais Ludique-expérientiel",
        age: "3-12 ans",
        price: "40 €/mois",
        description: "À travers les jeux, la musique, les arts..."
      },
      {
        name: "Cirque en anglais",
        age: "6-12 ans",
        price: "35 €/mois",
        description: "Apprentissage des techniques de cirque en anglais"
      },
      {
        name: "ENJOY THE MUSIC",
        age: "5-8 ans",
        price: "40 €/mois",
        description: "Initiation musicale pour les plus jeunes"
      },
      {
        name: "LET'S PLAY GUITAR",
        age: "8-12 ans",
        price: "40 €/mois",
        description: "Apprentissage de la guitare pour enfants"
      }
    ]
  },
  contact: {
    info: "Plus d'informations et inscriptions",
    description: "Pour plus d'informations et/ou s'inscrire:",
    email: "info@gandaraschool.com"
  }
};